import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

// Renders children directly into document.body (outside the app's #root tree),
// so printable sheets (invoice/receipt/prescription) can be revealed via the
// `.printable-area` print CSS rule without being hidden by `.no-print`
// ancestors in the normal app layout (sidebar/topbar/dialogs).
let portalNode;
const getPortalNode = () => {
  if (!portalNode) {
    portalNode = document.getElementById('print-portal-root');
    if (!portalNode) {
      portalNode = document.createElement('div');
      portalNode.id = 'print-portal-root';
      document.body.appendChild(portalNode);
    }
  }
  return portalNode;
};

const PrintPortal = ({ children }) => {
  const [node] = useState(getPortalNode);

  useEffect(() => {
    return () => {
      // Leave the shared node in the DOM; just clear content on unmount of consumer.
    };
  }, [node]);

  return ReactDOM.createPortal(
    <div className="printable-area">{children}</div>,
    node
  );
};

export default PrintPortal;
